import { get } from 'svelte/store';
import { user_data, profile_data } from 'src/stores/account/user';
import { isVerivoxDevForceEnabled } from 'src/stores/features/dev/verivox-dev-force-enable';

/**
 * Checks if the energy price feature (Verivox integration) is enabled for the current user.
 *
 * Access is based on:
 * - User type (excludes installers unless Dev force-enable is on)
 * - Backend flag: de_users in profile_data
 * - Dev overlay: verivoxDevForceEnable (localStorage)
 */
export const isEnergyPriceFeatureEnabled = (): boolean => {
	const forceEnable = isVerivoxDevForceEnabled();
	const userData = get(user_data);
	const profileData = get(profile_data);

	if (forceEnable) {
		return true;
	}

	if (userData?.installer) {
		return false;
	}

	if (!profileData?.de_users) {
		return false;
	}

	return true;
};

/** True when the real backend de_users flag is present (ignores Dev force-enable). */
export const hasVerivoxBackendFlag = (): boolean => {
	return Boolean(get(profile_data)?.de_users);
};
